export default function About() {
  return (
    <div className="min-h-screen" style={{backgroundColor: '#3d4f3d'}}>
      <div className="relative overflow-hidden">
        <div className="max-w-7xl mx-auto">
          <div className="relative z-10 pb-8 bg-transparent sm:pb-16 md:pb-20 lg:pb-28 xl:pb-32">
            <main className="mt-10 mx-auto max-w-7xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 lg:px-8 xl:mt-28">
              {/* Header with curved text */}
              <div className="text-center mb-16">
                <svg viewBox="0 0 800 120" className="mx-auto" style={{maxWidth: '800px', width: '100%'}}>
                  <defs>
                    <path id="curve" d="M 50,100 Q 400,20 750,100" fill="transparent"/>
                  </defs>
                  <text style={{fill: '#d4c5a0', fontFamily: 'Tenor Sans', fontSize: '32px', letterSpacing: '0.3em'}}>
                    <textPath href="#curve" startOffset="50%" textAnchor="middle">
                      ABOUT THE DAY
                    </textPath>
                  </text>
                </svg>
              </div>

              {/* Content Grid */}
              <div className="mt-16">
                <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:gap-12">
                  {/* Left Column - Timings */}
                  <div className="space-y-8">
                    <div>
                      <h2 className="text-4xl font-bold mb-8" style={{color: '#d4c5a0', fontFamily: 'Cinzel'}}>TIMINGS</h2>
                      <div className="space-y-6" style={{color: '#d4c5a0', fontFamily: 'Cinzel'}}>
                        {/* Timeline items */}
                        <div className="flex gap-6">
                          <span className="text-2xl w-24">12:00</span>
                          <div className="flex-1">
                            <span className="text-2xl">BAR OPENS</span>
                            <p className="text-sm mt-1" style={{fontFamily: 'Tenor Sans', opacity: 0.8}}>Day Guests Arrive</p>
                          </div>
                        </div>
                        <div className="flex gap-6">
                          <span className="text-2xl w-24">13:00</span>
                          <span className="text-2xl flex-1">CEREMONY</span>
                        </div>
                        <div className="flex gap-6">
                          <span className="text-2xl w-24">13:40</span>
                          <span className="text-2xl flex-1">CONFETTI AND PHOTOS</span>
                        </div>
                        <div className="flex gap-6">
                          <span className="text-2xl w-24">15:00</span>
                          <div className="flex-1">
                            <span className="text-2xl">FOOD</span>
                            <p className="text-sm mt-1" style={{fontFamily: 'Tenor Sans', opacity: 0.8}}>Meatball Lasagna, Carbonara or Vegetarian Option</p>
                            <p className="text-sm" style={{fontFamily: 'Tenor Sans', opacity: 0.8}}>Includes a Potato & Salad Bar</p>
                          </div>
                        </div>
                        <div className="flex gap-6">
                          <span className="text-2xl w-24">17:15</span>
                          <span className="text-2xl flex-1">SPEECHES</span>
                        </div>
                        <div className="flex gap-6">
                          <span className="text-2xl w-24">18:00</span>
                          <span className="text-2xl flex-1">EVENING GUESTS ARRIVE</span>
                        </div>
                        <div className="flex gap-6">
                          <span className="text-2xl w-24">18:15</span>
                          <span className="text-2xl flex-1">CUT THE WEDDING CAKE</span>
                        </div>
                        <div className="flex gap-6">
                          <span className="text-2xl w-24">18:30</span>
                          <span className="text-2xl flex-1">PARTY</span>
                        </div>
                        <div className="flex gap-6">
                          <span className="text-2xl w-24">20:30</span>
                          <div className="flex-1">
                            <span className="text-2xl">PIZZA</span>
                            <p className="text-sm mt-1" style={{fontFamily: 'Tenor Sans', opacity: 0.8}}>Choice of Margherita, BBQ and Hawaiin</p>
                          </div>
                        </div>
                        <div className="flex gap-6">
                          <span className="text-2xl w-24">23:30</span>
                          <span className="text-2xl flex-1">LAST ORDERS</span>
                        </div>
                        <div className="flex gap-6">
                          <span className="text-2xl w-24">00:00</span>
                          <span className="text-2xl flex-1">TAXIS</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Right Column - Useful Information, Map and Taxis */}
                  <div className="space-y-8">
                    {/* Useful Information Section */}
                    <div>
                      <h2 className="text-4xl font-bold mb-8" style={{color: '#d4c5a0', fontFamily: 'Cinzel'}}>GENERAL INFORMATION</h2>
                      <ul className="space-y-4" style={{color: '#d4c5a0', fontFamily: 'Tenor Sans', fontSize: '1.125rem'}}>
                        <li className="flex gap-3">
                          <span>•</span>
                          <span>Typical Wedding Attire</span>
                        </li>
                        <li className="flex gap-3">
                          <span>•</span>
                          <span>There is plenty of parking on site. Cars can be left overnight and collected the next morning</span>
                        </li>
                        <li className="flex gap-3">
                          <span>•</span>
                          <span>Durrington-on-Sea Train Station is a 10 Minute walk away</span>
                        </li>
                        <li className="flex gap-3">
                          <span>•</span>
                          <span>We don't expect any gifts however, donations towards the Honeymoon would not be turned away! Details on this can be found on your invitation, or a letter box will be available at the venue</span>
                        </li>
                        <li className="flex gap-3">
                          <span>•</span>
                          <span>Plus ones are welcome from 18:00 onwards for the evening reception (please add them to your RSVP)</span>
                        </li>
                      </ul>
                    </div>

                    {/* Map and Taxis Grid */}
                    <div className="grid grid-cols-2 gap-8">
                    {/* Map Section */}
                    <div>
                      <h2 className="text-4xl font-bold mb-8" style={{color: '#d4c5a0', fontFamily: 'Cinzel'}}>MAP</h2>
                      <div className="rounded-lg overflow-hidden shadow-lg">
                        <iframe
                          title="Field Place Wedding Venue Location"
                          src="https://maps.google.com/maps?q=Field+Place,+Worthing,+BN13+1NP&output=embed"
                          width="100%"
                          height="300"
                          style={{border: 0}}
                          allowFullScreen=""
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                        ></iframe>
                      </div>
                    </div>

                    {/* Taxis Section */}
                    <div>
                      <h2 className="text-4xl font-bold mb-8" style={{color: '#d4c5a0', fontFamily: 'Cinzel'}}>TAXIS</h2>
                      <div className="space-y-6" style={{color: '#d4c5a0', fontFamily: 'Cinzel'}}>
                        <div>
                          <p className="text-2xl mb-1">ARROW</p>
                          <a href="tel:01903212121" className="text-lg hover:underline" style={{color: '#d4c5a0', fontFamily: 'Tenor Sans'}}>01903 212121</a>
                        </div>
                        <div>
                          <p className="text-2xl mb-1">BRIGHTON TAXIS</p>
                          <a href="tel:01273204060" className="text-lg hover:underline" style={{color: '#d4c5a0', fontFamily: 'Tenor Sans'}}>01273 202020</a>
                        </div>
                      </div>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  );
}
